import { render, staticRenderFns } from "./EditServiceDescriptions.vue?vue&type=template&id=3b67ce61&"
import script from "./EditServiceDescriptions.vue?vue&type=script&lang=js&"
export * from "./EditServiceDescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports